import { useEffect } from "react";

const worksheetUrl = `${process.env.PUBLIC_URL || ""}/documents/how-i-got-here-worksheet.pdf`;

export default function LookingBack() {
  useEffect(() => {
    window.location.replace(worksheetUrl);
  }, []);

  return (
    <main className="container py-5">
      <h1>How I Got Here</h1>
      <p>
        Opening your worksheet. <a href={worksheetUrl}>Open the PDF</a>
      </p>
      <a href={worksheetUrl} download="how-i-got-here-worksheet.pdf">
        Download worksheet
      </a>
    </main>
  );
}
